module.exports = __webpack_public_path__ + "static/media/pause.10e4ae01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/pause.svg
// module id = 448
// module chunks = 0